<template>
	<div>
		<el-dialog :title="'停止降赔设置'" :visible.sync="show" width="550px" center>
			<div style="margin-left: 40px">
				<el-form :inline="true" :model="filters" width="550px">
					<el-form-item :label="$t('Operator')" v-show="zong">
						<el-select v-model="sellerid" @change="changeSellerId" :placeholder="$t('Operator')" style="width: 130px" :disabled="selleriddisabled">
							<el-option v-for="item in seller" :key="item.SellerId" :label="item.SellerName"
									   :value="item.SellerId"> </el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item :label="$t('Game')+':'">
					<el-select v-model="gameid" :placeholder="$t('Game')" style="width: 130px" :disabled="gameiddisabled" @change="handleGameChange">
						<el-option v-for="item in games" :key="item.id" :label="item.name" :value="item.id"> </el-option>
					</el-select>
				</el-form-item> -->
				</el-form>
				<el-form :inline="true" :model="filters">
					<el-form-item label="小于此投注金额不参与降赔(trx):"
								  v-if="((gameid % 100 < 6) || gameid == 11 || gameid == 12) && gameid != 101 && gameid != 102 && gameid != 131 && gameid != 132">
						<el-input v-model="limittrx"></el-input>
					</el-form-item>
					<el-form-item label="小于此投注金额不参与降赔(usdt):">
						<el-input v-model="limitusdt"></el-input>
					</el-form-item>
					<el-form-item label="距离上次投注时长(秒):"
								  v-if="((gameid % 100 < 6) || gameid == 11 || gameid == 12) && gameid != 101 && gameid != 102 && gameid != 131 && gameid != 132 && gameid != 301 && gameid != 302 && gameid != 331 && gameid != 332">
						<el-input v-model="betinterval"></el-input>
					</el-form-item>
					<el-form-item label="连续不下注达指定期数:" v-if="gameid < 8 || gameid > 100">
						<el-input v-model="betinterval">
							<template slot="append" style="background-color: white;">期</template>
						</el-input>
					</el-form-item>
					<div v-if="((gameid % 100 < 6) || gameid == 11 || gameid == 12) && gameid != 101 && gameid != 102 && gameid != 131 && gameid != 132 && gameid != 301 && gameid != 302 && gameid != 331 && gameid != 332">
						<p>规则，以下四种情况，都会停止降赔</p>
						<p>1、切换游戏</p>
						<p>2、切换下注类型（比如大，切小）</p>
						<p>3、输一次</p>
						<p>4、>后台设置的投注时长</p>
					</div>
					<div v-if="gameid < 8 || gameid > 100">
						<p>以下3种情况触发任意一个都会停止降赔：</p>
						<p>1. 投注金额小于所设定的值将停止降赔；</p>
						<p>2. 连续不下注达到所设定的期数将停止降赔；</p>
						<p>3. 若单期总盈亏为输将停止降赔；</p>
						<!-- <p>2、{{ `同区域后台设置的${betinterval}期没有下注，停止降陪` }}</p> -->
					</div>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="handleCommit()">{{$t('Save')}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { app } from '@/api/app.js'
import '@/assets/css/k.css'
import base from '@/api/base.js'
export default {
	extends: base,
	data() {
		return {
			show: false,
			betinterval: null,
			limittrx: null,
			limitusdt: null,
			gameid: null,
			sellerid: null,
			gameiddisabled: false,
			selleriddisabled: true,
			games: [
				{
					id: 1,
					name: '哈希大小',
				},
				{
					id: 2,
					name: '哈希单双',
				},
			],
		}
	},
	components: {},
	computed: {},
	created() { },
	methods: {
		showDialog(seller, gameid, channelid) {
			this.channelid = channelid
			this.betinterval = null
			this.limittrx = null
			this.limitusdt = null
			this.gameid = gameid
			this.gameiddisabled = true
			if (seller) {
				this.sellerid = seller
				this.selleriddisabled = true
			}
			let reqdata = {
				SellerId: seller,
				GameId: gameid,
				ChannelId: this.channelid,
			}
			app.post('/game/get_stopjiangpei', reqdata, (result) => {
				result = JSON.parse(result.data)
				this.limittrx = result.LimitTrx
				this.limitusdt = result.LimitUsdt
				this.betinterval = result.BetInterval
				this.show = true
			})
		},
		handleCommit() {
			app.getGoogleCode((GoogleCode) => {
				let reqdata = {
					SellerId: this.sellerid,
					GameId: this.gameid,
					BetInterval: Number(this.betinterval),
					LimitTrx: Number(this.limittrx),
					LimitUsdt: Number(this.limitusdt),
					ChannelId: this.channelid,
					GoogleCode: GoogleCode,
				}
				app.post('/game/set_stopjiangpei', reqdata, () => {
					this.show = false
					this.$message.success('保存成功')
				})
			})
		},
		handleGameChange() {
			let reqdata = {
				SellerId: this.sellerid,
				GameId: this.gameid,
				ChannelId: this.channelid,
			}
			app.post('/game/get_stopjiangpei', reqdata, (result) => {
				result = JSON.parse(result.data)
				this.limittrx = result.LimitTrx
				this.limitusdt = result.LimitUsdt
				this.betinterval = result.BetInterval
			})
		},
	},
	// destroyed: {},
}
</script>
